/**
 * LocalStorage utility functions for centralized storage management
 */

/**
 * Gets a value from localStorage
 * @param key - The key to retrieve
 * @returns The value from localStorage or null if not found
 */
export const getFromLocalStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`Error reading from localStorage for key "${key}":`, error);
    return null;
  }
};

/**
 * Sets a value in localStorage
 * @param key - The key to store under
 * @param value - The value to store
 */
export const setToLocalStorage = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(`Error writing to localStorage for key "${key}":`, error);
  }
};

/**
 * Removes a value from localStorage
 * @param key - The key to remove
 */
export const removeFromLocalStorage = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing from localStorage for key "${key}":`, error);
  }
};

/**
 * Clears all values from localStorage
 */
export const clearLocalStorage = (): void => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};
